import 'slick-carousel';

import $ from 'jquery';

import CTAs from '../partials/ctas';
import Showcase from './showcase';

class Showcase_tabbed {
  constructor($el) {
    this.$el = $el;
    this.$tab = this.$el.find('.showcase_tabbed__tab-cta');
    this.$tabContents = this.$el.find('.showcase_tabbed__tab-contents');
		this.$sliderMobileTop = this.$el.find('.showcase_tabbed__tab-ctas > p');
    this.$sliderMobileBottom = this.$el.find('.showcase_tabbed__tab-contents');
    this.autoSwitchInterval = null;
    this.init();
  }

  init() {
    this.sliderTop();
    this.sliderBottom();

    this.tabInitialization();
    this.sliderTopInitialization();
    this.sliderBottomInitialization();

    this.sectionHeight();

    const that = this;
    $(window).on("resize", function () {
      that.tabInitialization();
      that.sliderTopInitialization();
      that.sliderBottomInitialization();
      that.sectionHeight();
    });

    this.tab();
    this.startAutoSwitch();
    this.addClickListenerToStopAutoSwitch();
    new CTAs(this.$tabContents.find('.ctas'));
  }

  tabInitialization() {
    if (window.innerWidth >= $phpVars.breakpoint["screen-lg"]) {
        this.tab();
    }
  }

  tab() {
    this.$tab.on('click', (e) => {
      const $clickedTab = $(e.currentTarget);
      const tabId = $clickedTab.data('tab');

      this.$tab.removeClass('active');
      this.$tabContents.find('[data-panel]').removeClass('active');

      $clickedTab.addClass('active');

      this.$tabContents.find(`[data-panel="${tabId}"]`).addClass('active');

      const $slider = this.$tabContents.find('.showcase__gallery.slider');
      $slider.slick("refresh");

      // Reinitialize Showcase for the active tab
      const $activeShowcase = this.$tabContents.find(`[data-panel="${tabId}"] .showcase`);
      if ($activeShowcase.length) {
        new Showcase($activeShowcase);
      }

      this.stopAutoSwitch();

    });
  }

  isSliderTopInitialized() {
    return this.$sliderMobileTop.hasClass("slick-initialized");
  }

  sliderTopInitialization() {
    if (typeof this.$sliderMobileTop === "undefined") {
      return;
    }
  
    if (window.innerWidth < $phpVars.breakpoint["screen-lg"]) {
      if (!this.isSliderTopInitialized()) {
        this.sliderTop();
        const $slider = this.$tabContents.find('.showcase__gallery.slider');
        $slider.slick("refresh");
      }
    } else {
      if (this.isSliderTopInitialized()) {
        this.$sliderMobileTop.slick("unslick");
      }
    }
  }

  sliderTop() {
    if (typeof this.$sliderMobileTop === "undefined") {
      return;
    }

    if (this.$sliderMobileTop.find('> button').length <= 1) {
      return;
    }

    this.$sliderMobileTop.slick({
      adaptiveHeight: false,
      autoplay: true,
      fade: true,
      autoplaySpeed: 3000,
      speed: 500,
      arrows: true,
      dots: false,
      infinite: true,
      mobileFirst: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      asNavFor: this.$sliderMobileBottom
    });

    this.$sliderMobileTop.on('mousedown touchstart', () => {
      this.$sliderMobileTop.slick('slickPause');
      this.$sliderMobileBottom.slick('slickPause');
    });
  }

  isSliderBottomInitialized() {
    return this.$sliderMobileBottom.hasClass("slick-initialized");
  }

  sliderBottomInitialization() {
    if (typeof this.$sliderMobileBottom === "undefined") {
      return;
    }
  
    if (window.innerWidth < $phpVars.breakpoint["screen-lg"]) {
      if (!this.isSliderBottomInitialized()) {
        this.sliderBottom();
      }
    } else {
      if (this.isSliderBottomInitialized()) {
        this.$sliderMobileBottom.slick("unslick");
      }
    }
  }

  sliderBottom() {
    if (typeof this.$sliderMobileBottom === "undefined") {
			return;
		}

		if (this.$sliderMobileBottom.find('> div').length <= 1) {
			return;
		}

    this.$sliderMobileBottom.slick({
      adaptiveHeight: false,
      autoplay: true,
      fade: true,
      autoplaySpeed: 3000,
      speed: 500,
      arrows: false,
      dots: false,
      infinite: true,
      mobileFirst: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      asNavFor: this.$sliderMobileTop
    });

    this.$sliderMobileBottom.on('mousedown touchstart', () => {
      this.$sliderMobileTop.slick('slickPause');
      this.$sliderMobileBottom.slick('slickPause');
    });
	}

  startAutoSwitch() {
    this.autoSwitchInterval = setInterval(() => {
      const $activeTab = this.$el.find('.showcase_tabbed__tab-cta.active');
      const $nextTab = $activeTab.next('.showcase_tabbed__tab-cta').length 
        ? $activeTab.next('.showcase_tabbed__tab-cta') 
        : this.$tab.first();

      $nextTab.addClass('active').siblings().removeClass('active');

      const tabId = $nextTab.data('tab');
      this.$tabContents.find('[data-panel]').removeClass('active');
      const $activePanel = this.$tabContents.find(`[data-panel="${tabId}"]`);
      $activePanel.addClass('active');
      
      // Reinitialize Showcase for the active tab
      const $activeShowcase = $activePanel.find('.showcase');
      if ($activeShowcase.length) {
        new Showcase($activeShowcase);
      }

      const $slider = this.$tabContents.find('.showcase__gallery.slider');
      $slider.slick("refresh");

    }, 3000);
  }

  stopAutoSwitch() {
    if (this.autoSwitchInterval) {
      clearInterval(this.autoSwitchInterval);
      this.autoSwitchInterval = null;
    }
  }

  addClickListenerToStopAutoSwitch() {
    this.$tabContents.on('click', () => {
      this.stopAutoSwitch();
    });
  }

  
  sectionHeight() {
    $(() => {
      if (window.innerWidth > 991) {
        let maxHeight = 0;

        this.$tabContents.find('[data-panel]').each((_, element) => {
          const originalDisplay = element.style.display;
          const originalVisibility = element.style.visibility;

          element.style.display = 'block';
          element.style.visibility = 'hidden';

          const $element = $(element);
          const $slider = $element.find('.showcase__gallery.slider');
          if ($slider.length > 0) {
            $slider.slick("refresh");
          }

          const height = element.offsetHeight;

          element.style.display = originalDisplay;
          element.style.visibility = originalVisibility;

          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        if (maxHeight > 0) {
          this.$tabContents.css('min-height', `${maxHeight}px`);
        }
      } else {
          this.$tabContents.css('min-height', 'unset');
      }
    });
  }
  
}

export default Showcase_tabbed;
